export default __webpack_public_path__ + "static/media/pink-thin.7bf7cf3a.webp";